/** Three simple steps + CTA. */
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { marketingEvent } from '@/lib/marketing';

const STEPS = [
  { number: 1, title: 'Set up your restaurant', text: 'Add your locations and employees — or import your whole roster from a spreadsheet in minutes.' },
  { number: 2, title: 'Build your rota', text: 'Create shifts and assign staff. Publish the week so everyone sees it in the employee portal.' },
  { number: 3, title: 'Track & finalise', text: 'Monitor attendance as the week happens and review hours before payroll.' },
];

export function HowItWorksSection({ onBookDemo }) {
  return (
    <section id="how-it-works" className="bg-[color:var(--brand-bg-2)] border-y border-[color:var(--brand-border)] scroll-mt-24 [content-visibility:auto]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-14 sm:py-20">
        <h2 className="text-3xl sm:text-4xl font-display font-semibold tracking-tight text-center" data-testid="marketing-how-heading">
          Up and running in three steps
        </h2>
        <div className="mt-9 grid sm:grid-cols-3 gap-4 sm:gap-5">
          {STEPS.map((step) => (
            <article key={step.number} className="surface-card p-5 sm:p-6" data-testid={`marketing-how-step-${step.number}`}>
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[color:var(--brand-primary-soft)] text-[color:var(--brand-primary)] font-semibold">
                {step.number}
              </span>
              <h3 className="mt-4 font-display text-lg font-semibold">{step.title}</h3>
              <p className="mt-1.5 text-sm text-[color:var(--brand-text-muted)] leading-relaxed">{step.text}</p>
            </article>
          ))}
        </div>
        <div className="mt-9 flex flex-col sm:flex-row justify-center gap-3">
          <Button asChild className="h-12 rounded-xl px-6 bg-[color:var(--brand-primary)] hover:bg-[color:var(--brand-primary-hover)] text-white font-semibold transition-colors duration-150">
            <Link to="/signup" onClick={() => marketingEvent('click_start_trial', { placement: 'how_it_works' })} data-testid="marketing-how-it-works-start-trial-button">
              Start Your Free Trial
            </Link>
          </Button>
          <Button variant="outline" className="h-12 rounded-xl px-6 bg-white border-[color:var(--brand-border)] font-semibold hover:bg-[color:var(--brand-bg-2)] transition-colors duration-150" onClick={() => onBookDemo('how_it_works')} data-testid="marketing-how-it-works-book-demo-button">
            Book a Demo
          </Button>
        </div>
      </div>
    </section>
  );
}
